/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dealreview_Viewdocument3Inputs */

const en_coinvestments_dealreview_viewdocument3 = /** @type {(inputs: Coinvestments_Dealreview_Viewdocument3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View document`)
};

/**
* | output |
* | --- |
* | "View document" |
*
* @param {Coinvestments_Dealreview_Viewdocument3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dealreview_viewdocument3 = /** @type {((inputs?: Coinvestments_Dealreview_Viewdocument3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dealreview_Viewdocument3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dealreview_viewdocument3(inputs)
});
export { coinvestments_dealreview_viewdocument3 as "coInvestments_dealReview_viewDocument" }